<template>
  <div class="SBbetSlip" :class="[betSlipState[currentBetSlipState], {hasErrors: showError}, errorId]">
    <div class="betslipHeader">
      <div v-if="false">
        <span>{{ $t('BetSlip.title') }}</span>
        <span>: {{betsNo}}</span>
        | State: {{ currentBetSlipState }} |
        | StateName: {{ betSlipState[currentBetSlipState] }} |
      </div>

      <div class="tabs is-boxed is-centered is-fullwidth is-toggle">
          <span v-if="false" class="tab" :class="{ 'active': tab==='S', disabled: true }">
            <a @click="setTab('S')" class="a-link-" :class="{ disabled: betsNo===0 }">
               <span>{{ $t('BetSlip.tab.S') }}</span>
            </a>
          </span>
        <span class="tab" :class="{ 'active': tab==='REGULAR', disabled: true }">
            <a @click="setTab('REGULAR')" class="a-link-" :class="{ disabled: betsNo===0 }">
              <span>{{ $t('BetSlip.tab.REGULAR') }}</span>
            </a>
          </span>
        <span class="tab" :class="{ 'active': tab==='TEASER' }">
            <a @click="setTab('TEASER')" class="a-link" :class="{ disabled: betsNo<=1 }">
               <span>{{ $t('BetSlip.tab.TEASER') }}</span>
            </a>
          </span>
        <span class="tab" :class="{ 'active': tab==='RR' }">
            <a @click="setTab('RR')" class="a-link" :class="{ disabled: betsNo<=2 }">
               <span>{{ $t('BetSlip.tab.RR') }}</span>
            </a>
          </span>
      </div>
    </div>
    <div class="add-bets-container" v-if="!betsNo">
      <span class="pd-icon pd-icon-plus-sign"></span>
      <div class="ab-info-msg">
        <span class="ab-label">{{ $t('BetSlip.add.bets') }}</span>
        <span class="ab-label" v-html="$t('BetSlip.zero.bets')"></span>
      </div>
    </div>
    <div style="clear:both;"></div>
    <input v-if="!gettingABTnR" type="hidden" :value="calculateWin()" />

    <div v-if="!betsNo" class="empty-betslip" :class="tab">
      <div :class="tab" class="msg">
      </div>
    </div>
    <div v-else>
    <div class="bets" v-show="!(currentBetSlipState==5 && betSlipStatus.State==2)">
      <div v-if="tab==='REGULAR'" :class="tab" >
        <div v-if="betsNo >= 2">
          <parlay :betsNo="betsNo"
                    :allowedBetTypesAndReturns="allowedBetTypesAndReturns.REGULAR"
                    :allowedBetTypesPRL="allowedBetTypesPRL"
                    :currentBetSlipState="currentBetSlipState"
                    :gettingABTnR="gettingABTnR"
                    :betTypeStakes="betTypeStakes.REGULAR.PerBetType"
                    :winnings="winnings.REGULAR.PerBetType"
                    @initPlaceBet="initPlaceBet()"
                    @placeBet="placeBet()"
                    @cancelBet="cancelBet()" >
          </parlay>
        </div>
      </div>


      <div v-if="tab==='REGULAR' || tab==='RR'" :class="tab" class="singles">
        <div class="header-SING" :class="{focused:focus[0], 'non-empty':!!multiSinglesStake}" v-if="tab==='REGULAR' && currentBetSlipState<1" >
          <h2 class="betslip-tab-title">{{ $t('BetSlip.tab.title.SINGLE' + (betsNo > 1 ? 'S':'')) }}</h2>
          <!--v-show-="allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType.C1"-->
          <span class="stakeAll"  v-show="betsNo>1 && currentBetSlipState<1">
            <span class="multiSinglesStake">
              <money-input v-model="multiSinglesStake"
                           :id="1"
                           :placeholder="$t('BetSlip.single.stakeAll')"
                           :disabled="currentBetSlipState>=1"
                           :focus="focus"
                           :className="'input-only'"
                           @setFocus="setFocus"
                           @dismissError="dismissBetSlip(null, true)"
              >
                      </money-input>

            </span>
          </span>
        </div>

        <bet-slip-selection v-for="selectionId in betslipSelectionIds"
                            :isFor="'REGULAR'"
                            :selectionId="selectionId" :key="selectionId" :tab="tab"
                            :betTypeStakes="betTypeStakes.REGULAR.PerSelection"
                            :betTypeStakesPerBetType="betTypeStakes.REGULAR.PerBetType"
                            :allowedBetTypesAndReturns="allowedBetTypesAndReturns.REGULAR"
                            :winnings="winnings.REGULAR.PerSelection"
                            :multiSingles="multiSingles"
                            :multiSinglesStake="multiSinglesStake"
                            :currentBetSlipState="currentBetSlipState"
                            :isLive="checkLive(selectionId)"
                            @removeSelection="removeSelection"
                            @updateSelected="updateSelected" >
        </bet-slip-selection>

      </div>



        <div v-if="tab==='TEASER'" :class="tab">
          <teaser
            :tab="tab"
            :betsNo="betsNo"
            :allowedBetTypesAndReturns="allowedBetTypesAndReturns"
            :allowedBetTypesPRL="allowedBetTypesPRL"
            :allowedBetTypesRR="allowedBetTypesRR"
            :currentBetSlipState="currentBetSlipState"
            :gettingABTnR="gettingABTnR"
            :betTypeStakes="betTypeStakes.TEASER"
            :winnings="winnings.TEASER"
            @initPlaceBet="initPlaceBet()"
            @placeBet="placeBet()"
            @cancelBet="cancelBet()"
            @setTeaserType="setTeaserType"
            @updateSelected="updateSelected"
          >
          </teaser>
        </div>

        <div v-if="tab==='RR'" :class="tab">
          <round-robin :betsNo="betsNo"
                       :betslipSelections="betslipSelectionIds"
                       :allowedBetTypesAndReturns="allowedBetTypesAndReturns.RR"
                       :allowedBetTypesRR="allowedBetTypesRR"
                       :allowedBetTypesPRL="allowedBetTypesPRLRR"
                       :activeRR="activeRR"
                       :currentBetSlipState="currentBetSlipState"
                       :gettingABTnR="gettingABTnR"
                       :betTypeStakes="betTypeStakes.RR.PerBetType"
                       :winnings="winnings.RR.PerBetType"
                       @initPlaceBet="initPlaceBet()"
                       @placeBet="placeBet()"
                       @cancelBet="cancelBet()"
                       @calculateWin="calculateWin"
                       @updateSelected="updateSelected"
          ></round-robin>
        </div>

      </div>
    </div>

   <div class="fixed_footer_sep" :style="betslipActionsHeight" :class="{'bet_placed' : betSlipStatus.State==2}"></div>
   <div class="betslip_actions" ref="betActions" :class="{'bet_placed' : betSlipStatus.State==2}">

    <div class="action-msg" v-if="betsNo">


      <!-- <div v-if="currentBetSlipState==0.5 || (showBetSlipChanged && !showError)" id="BetSlipChanged" class="align-center">
        <h3>{{ $t('BetSlip.changed.title') }} </h3>
        <div v-if="betSlipChanges.closed.length">{{ $t('BetSlip.changed.closed') }} </div>
        <div v-if="betSlipChanges.suspended.length">{{ $t('BetSlip.changed.suspended') }}</div>
        <div v-if="betSlipChanges.price.length">{{ $t('BetSlip.changed.price') }}</div>
        <div v-if="betSlipChanges.currenthandicap.length">{{ $t('BetSlip.changed.currenthandicap') }}</div>
        <button class="btn secondary" @click="acceptChanges()"> {{ $t('BetSlip.placement.btn.OK') }} </button>
      </div> -->


      <div class="betPlacement" v-if="currentBetSlipState > 1" :class="{'bet_placed' : betSlipStatus.State==2}">
        <div v-if="currentBetSlipState==2" class="align-center">
          <div class="loading">
            <span>{{ $t('BetSlip.status.placing-in') }}</span>
            <span>
              <!--<span class="countDown">{{inRunningDelay}}</span>-->
              <circle-loader-with-counter :n="inRunningDelay"></circle-loader-with-counter>
            </span>

          </div>

        </div>

        <div v-if="currentBetSlipState==3" class="align-center">

          <h3 v-if="inRefferal" >
            <span v-html="$t('BetSlip.status.acceptable.referred.reOffered')"></span>
          </h3>

          <div v-if="inRefferal" class="msg" :class="{'inRefferal':inRefferal}">
            <span>{{ $t('BetSlip.betPlacementStatus.Status.detailed.referred.reOffered') }}</span>
          </div>

          <div class="loading">
            <circle-loader></circle-loader>
            <!--<circle-loader-with-counter :n="''"></circle-loader-with-counter>-->
          </div>
        </div>
        <div v-if="currentBetSlipState==4" class="align-center">
          <div class="loading">
            <dots-loader></dots-loader>
          </div>
        </div>

        <div v-if="currentBetSlipState==5" class="align-center">
          <div v-if="betSlipStatus.State==2">
            <img src="~@/assets/images/betslip/CheckMark.svg" class="bet_placed_img" alt="Betslip">
            <h3>
              <!-- <span v-if="betPlacementResult.result.Bets.length==1">{{ $t('BetSlip.status.placed') }}</span> -->
              <!-- <span v-else >{{ $t('BetSlip.status.placed.pl', {n:numberOfSucessfulyPlacedBets}) }}</span> -->
              <span key="betplacedsing" v-if="numberOfSucessfulyPlacedBets==1">{{ $t('BetSlip.status.placed') }}</span>
              <span key="betplacedpl" v-if="numberOfSucessfulyPlacedBets > 1">{{ $t('BetSlip.status.placed.pl', {n:numberOfSucessfulyPlacedBets}) }}</span>
              <span v-if="numberOfSucessfulyPlacedBets < betPlacementResult.result.Bets.length">
                <br>
                <span key="betfailedsing" v-if="(betPlacementResult.result.Bets.length - numberOfSucessfulyPlacedBets) == 1">{{ $t('BetSlip.status.placed.failed') }}</span>
                <span key="betfailedpl" v-else>{{ $t('BetSlip.status.placed.failed.pl', {n:betPlacementResult.result.Bets.length - numberOfSucessfulyPlacedBets}) }}</span>
              </span>
            </h3>
            <span class="goodLuck_text">{{ $t('BetSlip.status.placed.GoodLuck') }}</span>
          </div>
          <div v-if="betSlipStatus.State==4">
            <h3>
              <span v-if="!errorType">
                {{ $t('BetSlip.status.rejected') }}
              </span>
              <span v-else>
                {{ $t('BetSlip.placement.error.' + errorType + '.' + 'result') }}
                 </span>
            </h3>
            <div class="reject-reason" v-if="betPlacementResult.result.Status.StatusText">
              <span v-html="betPlacementResult.result.Status.StatusText"></span>
            </div>
          </div>
          <div v-if="betSlipStatus.State==5">
            <h3>
              <span v-if="inRefferal">{{ $t('BetSlip.status.waiting.reffer') }}</span>
              <span v-else>{{ $t('BetSlip.status.waiting') }}</span>
            </h3>

            <div v-for="reason in betPlacementResult.result.Status.detailedStates">
              <span>{{ $t('BetSlip.betPlacementStatus.Status.detailed.' + reason) }}</span>
              <span v-if="reason==='reOffered'"><strong>$ {{betPlacementResult.result.TotalStake.toFixed(2)}}</strong></span>
            </div>
            <div class="loading">
              <circle-loader></circle-loader>
            </div>
          </div>
        </div>
        <div v-if="currentBetSlipState==6" class="align-center">
          <h3 v-if="betSlipStatus.State==1" class="Bet-Acceptable">
            <span v-if="betPlacementResult.result.Status.detailedStates && betPlacementResult.result.Status.detailedStates.indexOf('reOffered')>-1">
              <span v-if="inRefferal">{{ $t('BetSlip.status.acceptable.referred.reOffered') }}</span>
              <span v-else> {{ $t('BetSlip.status.acceptable.reOffered') }} </span>
            </span>
            <span v-else>{{ $t('BetSlip.status.acceptable') }}</span>
          </h3>
          <h3 v-if="betSlipStatus.State==3" class="Bet-Reoffered">
            <span v-if="betPlacementResult.result.Status.detailedStates && betPlacementResult.result.Status.detailedStates.indexOf('reOffered')>-1">
              <span>{{ $t('BetSlip.status.reoffered.reOffered') }}</span>
            </span>
            <span v-else>{{ $t('BetSlip.status.acceptable') }}</span>
           </h3>
          <div class="msg bet_actions_msg" :class="{'inRefferal':inRefferal}">
            <div v-for="reason in betPlacementResult.result.Status.detailedStates">
              <span v-if="inRefferal && reason=='reOffered'">
                <span>{{ $t('BetSlip.betPlacementStatus.Status.detailed.referred.' + reason) }}</span>
                <br><span> {{ $t('BetSlip.betPlacementStatus.Status.detailed.referred.reOffered.scroll') }}</span>
              </span>
              <span v-else>{{ $t('BetSlip.betPlacementStatus.Status.detailed.' + reason) }}</span>
            </div>
          </div>

          <div v-if="!inRefferal">{{ $t('BetSlip.status.confirmIn') }} {{ gracePeriod }}</div>
          <div v-else v-show="gracePeriod"><circle-loader-with-counter :n="gracePeriod"></circle-loader-with-counter></div>

          <div v-for="reason in betPlacementResult.result.Status.detailedStates" v-if="!inRefferal">
            <span v-if="reason=='reOffered'">{{ $t('BetSlip.betPlacementStatus.Status.detailed.reOffered.call') }}</span>
          </div>

        </div>

        <div v-if="currentBetSlipState==7" class="align-center">
          <h3>{{ $t('BetSlip.status.canceled') }}</h3>
        </div>
        <div v-if="currentBetSlipState==8" class="align-center">
          <h3>{{ $t('BetSlip.status.timedOut') }}</h3>
        </div>


        <div id="betSlipReceipt" :class="tab" v-if="(currentBetSlipState==5 || currentBetSlipState==6) && betPlacementResult.result && betSlipStatus.State==2">
          <div v-if="betSlipStatus.State==2" class="totals">
            <div class="reference" v-if="betPlacementResult.result.ExternalReference">
              <!-- {{ $t('BetSlip.receipt.reference') }}{{betSlipRef(betPlacementResult.result)}}-->
              <label>{{ $t('BetSlip.receipt.reference') }}</label>
              <span class="value">{{betPlacementResult.result.ExternalReference}}</span>
            </div>
            <div class="wagered">
               <label>{{ $t('BetSlip.receipt.wagered') }}</label>
               <span class="value"> $ {{betPlacementResult.result.TotalStake.toFixed(2)}}</span>
            </div>
            <div class="potential-return">
              <label>{{ $t('BetSlip.receipt.winning.potential') }}</label>
              <span class="value"> $ {{attemptedBetPotentialReturn}}</span>
            </div>
          </div>

          <div class="receipt-details" v-if="showReceiptDetails" >
            <!-- <hr> -->
            <div v-for="bet in betPlacementResult.result.Bets" class="Bet" style="padding: 5px 0;" >
              <div>
                <div v-if="bet.IDFOBetType!='S'">
                  <strong>
                    <span>{{ $t('BetSlip.receipt.' + tab + '.betType.' + bet.IDFOBetType, {n:bet.BetLegs.length}) }}</span>
                  </strong>
                </div>
                <div>
                  <strong>
                    <span>{{ $t('BetSlip.receipt.' + tab + '.' + bet.IDFOBetType, {n:bet.BetLegs.length}) }}</span>
                  </strong>
                </div>
                <div>{{ $t('BetSlip.receipt.reference') }}: {{betTypeRef(bet)}}<br></div>
              </div>

              <div v-if="bet.IDFOBetType=='S'">
                <div v-for="leg in bet.BetLegs">
                  <!--<div>{{getSelectionById(leg.IDFOSelection)}}</div>-->
                  <div v-for="legSelection in getSelectionDataById(leg.IDFOSelection)">
                    <div class="selection-data" style="padding-left: 10px;">
                      <div class="event-name">{{legSelection.market.eventname}}
                        <span class="selection-ts" v-if="legSelection.market.tsstart" >
                          <!--<br>tsstart: {{legSelection.market.tsbetstart}}-->
                          <span class="time">{{ legSelection.market.tsstart | moment(dateFormats.longTime) }}</span>
                          <span class="date">{{ legSelection.market.tsstart | moment(dateFormats.shortDate) }}</span>
                        </span>
                      </div>
                      <div class="selection-name">
                        <strong>
                          <span class="name">
                            {{ formatSelectionName(legSelection.selection) }}
                           <span class="currenthandicap" v-if="legSelection.selection.currenthandicap" >{{ formatHandicap(legSelection.selection)}}</span>
                          </span>
                        </strong>
                      </div>
                      <div class="market-name">{{legSelection.market.name}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="betPlacementResult.result.Bets.length>=1">
                <div>{{ $t('BetSlip.receipt.stake.total') }}: $ {{bet.TotalStake.toFixed(2)}}</div>
                <!--
                Odds for Non-Singles hidden since they are recalculatad based on PotentialReturn,
                and they can not be calculated preciselly since other parameters used in calculation are previously rounded to 2 decimals.
                -->
                <div v-if="bet.IDFOBetType=='S'">{{ $t('BetSlip.receipt.odds') }}: {{formatOddsFromReturn(bet)}}</div>
                <div>{{ $t('BetSlip.receipt.return.potential') }}: $ {{(bet.PotentialReturn-bet.TotalStake).toFixed(2)}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="action-btns" v-show="betsNo || isLoggedIn" :class="[betSlipState[currentBetSlipState], {'inRefferal':inRefferal}]">
      <div v-if="currentBetSlipState==9 || showError" class="align-center">
        <!--errorId: {{errorId}}<br>-->
        <!--errorMsg: {{errorMsg}}<br>-->
        <div v-if="errorMsg" class="errorMsg" :class="errorId" >
          <icon name="icon-information" colorName="white"></icon>
           <span class="message" v-html="$t('BetSlip.placement.error.' + errorId, {uiView: this.isOpenedFromWebView ? '?uiView=true' : '',
                MAX_TAKEOUT: this.maxTakeOut,
                SLIP_TOTALSTAKE_MIN: this.slipTotalStakeMin,
                SLIP_TOTALSTAKE_MAX: this.slipTotalStakeMax,
                SLIP_TOTALSTAKE_MAX_INPLAY: this.slipTotalStakeMaxInPlay})"></span>
         </div>
        <div v-else class="errorMsg" >
          <icon name="icon-information" colorName="white"></icon>
          <span class="message">{{ $t('BetSlip.status.error') }}</span>
        </div>
        <div v-if="errors.OTHER" class="errorMsg" >
          <icon name="icon-information" colorName="white"></icon>
          <span class="message">{{errors.OTHER}}</span>
        </div>
      </div>

      <!-- PLACE BET -->
        <div class="align-center btn-container" v-show="currentBetSlipState==0 && betsNo">
          <div class="column column-right">
            <div v-show="!isLoggedIn" >
              <button class="btn primary-button primary-btn" @click="popLogIn()" >
                  <span>{{ $t('BetSlip.btn.msg.LogIn') }}</span>
              </button>
            </div>
            <div v-show="isLoggedIn" >
              <div class="betslip_total_cost">
                <div>
                  <div class="line1">
                    <span>{{ $t('BetSlip.btn.PlaceBet.TotalCost') }}</span>:  ${{this.betTypeStakes.PerTab[tab]}}
                  </div>
                  <div class="line2">
                    <span>{{ $t('BetSlip.btn.PlaceBet.TotalPotentialReturn') }}</span>:  ${{this.winnings.PerTab[tab]}}
                  </div>
                </div>
              </div>
              <!--showBetSlipChanged: {{showBetSlipChanged}}; showError: {{showError}}<br>-->
              <button v-if="showBetSlipChanged" class="btn acceptChanges" @click="acceptChanges()">
                {{ $t('BetSlip.changed.btn.accept') }}
              </button>
              <button v-else class="btn primary-button primary-btn" @click="initPlaceBet()"
                      :disabled="disablePlaceBet()" :class="disablePlaceBet()" >
                  <span class="btn-label">
                    <div v-show="gettingABTnR" class="loader-container">
                      <circle-loader></circle-loader>
                    </div>
                    <span>{{ $t('BetSlip.btn.PlaceBet') }}</span>
                  </span>
              </button>
            </div>
          </div>
        </div>
        <div v-if="!isOpenedFromWebView && !mobileBigAndBelow">
          <div class="not-geolocated" v-show="!isGeolocated && isLoggedIn">
            <div :key="geolocationMessage.errorCode + '-' + Math.random()" v-if="geolocationMessage.errorCode === 'verify'">
                <p class="pls-wait">{{ $t('BetSlip.pleaseWait') }}</p>
                <p class="verify">{{ $t('BetSlip.VerifyingLocation') }}</p>
              <div class="loader-container">
                  <circle-loader></circle-loader>
              </div>
            </div>
            <div :key="geolocationMessage.errorCode + '-' + Math.random()" v-if="(geolocationMessage.errorCode === 999 || geolocationMessage.errorCode === 612) || (errorMsgLocalStorage === '999' || errorMsgLocalStorage === '612')">
              <p>{{ $t('BetSlip.notLocated.' + state) }}</p>
              <p v-if="isHardGeolocation">{{ $t('BetSlip.tryAgain.' + state) }}</p>
            </div>
          </div>
        </div>
        <div class="align-center btn-container" v-show="currentBetSlipState==1 && betsNo">
          <div class="column column-left">
            <button class="btn" @click="cancelBet()" >
              <span>{{ $t('BetSlip.placement.btn.EDIT') }}</span>
            </button>
          </div>
          <div class="column column-right">
            <button v-if="showBetSlipChanged && !showError" class="btn acceptChanges" @click="acceptChanges()">
              {{ $t('BetSlip.changed.btn.accept') }}
            </button>
            <button v-else class="btn secondary" @click="placeBet()"
                    :disabled="disablePlaceBet()" :class="disablePlaceBet()" >
                  <span>
                    <div class="line1">
                      <span>{{ $t('BetSlip.placement.btn.CONFIRM') }}</span>
                    </div>
                  </span>
            </button>
          </div>
        </div>
        <div class="betPlacement" v-show="currentBetSlipState>1">
          <div v-if="currentBetSlipState==5" class="align-center">
            <div v-if="betSlipStatus.State==2" class="action_buttons">
              <div class="column column-left">
                <button class="btn secondary" @click="dismissBetSlip()">
                  {{ $t('BetSlip.placement.btn.DISMISS') }}
                </button>
              </div>
              <div class="column column-right">
                <button class="btn primary" @click="dismissBetSlip(true)">
                  <span v-if="betsNo==1" :key="betsNo">{{ $t('BetSlip.placement.btn.KEEP') }}</span>
                  <span v-else :key="betsNo">{{ $t('BetSlip.placement.btn.KEEP.pl') }}</span>
                </button>
              </div>
            </div>
            <div v-if="betSlipStatus.State==4">
              <button class="btn bet_rejected" @click="dismissBetSlip()"> {{ $t('BetSlip.placement.btn.OK') }} </button>
            </div>
            <div v-if="betSlipStatus.State==5 && betPlacementResult.result.Status.detailedStates &&
             betPlacementResult.result.Status.detailedStates.indexOf('referred')==-1" >
              <!--// No reject during referal-->
              <button class="btn btn_blue" @click="rejectBetSlip()"> {{ $t('BetSlip.placement.btn.CANCEL') }} </button>
            </div>
          </div>
          <div v-if="currentBetSlipState==6" class="align-center action_buttons">
              <div class="column column-left" v-if="inRefferal" >
                <button class="btn btn_white" @click="rejectBetSlip()"><icon name="icon-close-red"></icon>{{ $t('BetSlip.placement.btn.CANCEL.reffer') }} </button>
               </div>
              <div class="column column-right" v-if="inRefferal">
                <button class="btn btn_green" :class="{'inRefferal':inRefferal}" @click="confirmBetSlip()"><icon name="icon-tick" colorName="white"></icon>{{ $t('BetSlip.placement.btn.CONFIRM.reffer') }} </button>
              </div>
              <div class="column column-left" v-if="!inRefferal">
                <button class="btn btn_white" @click="confirmBetSlip()"> {{ $t('BetSlip.placement.btn.CONFIRM') }} </button>
              </div>
              <div class="column column-right" v-if="!inRefferal">
                <button class="btn btn_blue" @click="rejectBetSlip()"> {{ $t('BetSlip.placement.btn.CANCEL') }} </button>
              </div>
          </div>
          <div v-if="currentBetSlipState==7" class="align-center">
            <button class="btn secondary btn_blue" @click="dismissBetSlip(0,0,1)"> {{ $t('BetSlip.placement.btn.OK') }} </button>
          </div>
          <div v-if="currentBetSlipState==8" class="align-center">
            <button class="btn secondary btn_blue" @click="dismissBetSlip(0,0,1)"> {{ $t('BetSlip.placement.btn.OK') }}  </button>
          </div>
          <div v-if="currentBetSlipState==9" class="align-center">
            <button class="btn secondary btn_blue" @click="dismissBetSlip(0,0,1)"> {{ $t('BetSlip.placement.btn.OK') }}  </button>
          </div>

          <!--<button class="btn" @click="getBetSlipStatus()"> STATUS </button>-->
        </div>
       <div v-if="!mobileBigAndBelow" style="height:10px"></div>
       <div class="betslip_footer_bottom" v-if="currentBetSlipState==0 && betsNo">
          <v-btn @click="clearAll" class="delALL">
            <icon name="icon-trash"></icon><span>{{ $t('BetSlip.selection.btn.clearall') }} </span>
          </v-btn>
        <preference-switch v-if="betsNo && currentBetSlipState < 2" :label="'showAcceptingChangesInfoRI'" :id="'showAcceptingChangesInfo'" :currentBetSlipState="currentBetSlipState" > </preference-switch>
      </div>
    </div>
  </div>
    <!--<v-btn class="btn primary-button primary-btn" @click="openDialogSingleBetSlip()">Single Bet Slip</v-btn>-->

    <!--dialogSingleBetslip: {{dialogSingleBetslip}}<br>-->
    <v-dialog content-class="dialog-single-bet-slip" v-model="dialogSingleBetslip.active" persistent :hide-overlay="true" :fullscreen="false" transition="dialog-bottom-transition">
      <single-bet-slip :dialogSingleBetslip="dialogSingleBetslip" ></single-bet-slip>
    </v-dialog>


    <v-dialog content-class="dialog-betslip-confirm" v-model="dialogBetslipConfirm.active" persistent :fullscreen="false">
      <betslip-confirm :dialogBetslipConfirm="dialogBetslipConfirm" ></betslip-confirm>
    </v-dialog>


    <!--<button class="btn" @click="saveToStorage()"> STORAGE </button><br>-->
    <!--<a href="https://contentcts.webteam.beg.finsoft.com/cache/psbonav/1/UK/top.json" target="_blank">.json</a><br>-->
    <!--<br>-->
    <!--<input type="number" v-model="down_payment" class="form-control-right" placeholder="Downpayment" number>-->
    <!--<stake-input v-model="down_payment" @updateStake="updateStake"></stake-input>-->
    <!--<br>-->
    <!--<input type="number" v-model="loan_amount" placeholder="Loan Amount" number>-->
    <!--<br>-->
    <!--<div>betSlipStatus: {{ betSlipStatus }}</div>-->
    <!--{{betslipSelections}}-->
    <!--allowedBetTypesAndReturns: {{ allowedBetTypesAndReturns }}-->
    <!--<br>betSlipChanges: {{ betSlipChanges }}-->
    <!--<br>interRelated: {{ interRelated }}-->
    <!--<br>interRelatedLen: {{ interRelatedLen }}-->
    <!--<br> liveSelections: {{ liveSelections }}-->
    <!--gettingABTnR: {{gettingABTnR}}-->
    <!--betTypeStakes: {{betTypeStakes}}-->
    <!--<br>  allowedBetTypesAndReturns: {{allowedBetTypesAndReturns}}-->
    <!--<br>  allowedBetTypesAndReturns: {{allowedBetTypesAndReturns.PotentialReturns}}-->
    <!--<br>  allowedBetTypesAndReturns: {{allowedBetTypesAndReturns.PotentialReturns.PerBetType}}-->
    <!--<br>  allowedBetTypesSING: {{allowedBetTypesSING}}-->
    <!--<br>  allowedBetTypesPRLRR: {{allowedBetTypesPRLRR}}-->
    <!--<br>  allowedBetTypesPRL: {{allowedBetTypesPRL}}-->
    <!--<br>  showMultySingleWagerOption: {{showMultySingleWagerOption}}-->
    <!--<br>  allowedBetTypesPRL: {{allowedBetTypesPRL}}-->
    <!--<br>  betTypeStakes: {{betTypeStakes}}<hr>-->
    <!--<br>  winnings: {{winnings}}<hr>-->
    <!--<hr>  <br>  teasers: {{teasers}}-->
    <!--<hr>  <br>  betslipSelections: {{betslipSelections}}-->
    <!--<hr>  <br>  dateFormats: {{dateFormats}}-->
    <!--<hr>  <br>  betslipSelectionIds: {{betslipSelectionIds}}-->
    <!--<hr>  <br>  webViewAndMobile: {{webViewAndMobile}}-->
    <!--<hr>  <br>  isOpenedFromWebView: {{isOpenedFromWebView}}-->
    <!--<hr>  <br>  minValuesNotMet: {{minValuesNotMet}}-->
    <!--<hr>  <br>  disablePlaceBet: {{disablePlaceBet()}}-->
    <!--<hr>  <br>  closeFromParent: {{closeFromParent}}-->
    <!--<hr>  <br>  singleBetSlipSelection: {{singleBetSlipSelection}}-->
    <!--<hr>  <br>  inRefferal: {{inRefferal}}-->
    <!--<hr>  <br>  maxTakeOut: {{maxTakeOut}}-->
    <!--<hr>  <br>  slipTotalStakeMin: {{slipTotalStakeMin}}-->
    <!--<hr>  <br>  slipTotalStakeMax: {{slipTotalStakeMax}}-->
    <!--<hr>  <br>  slipTotalStakeMaxInPlay: {{slipTotalStakeMaxInPlay}}-->
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import parlay from './ParlayTab.vue'
  import teaser from './TeaserTab.vue'
  import roundRobin from './RoundRobinTab.vue'
  import betSlipSelection from './betslipSelection.vue'
  import stakeInput from './stakeInput.vue'
  import priceFormat from '@/library/priceFormat'
  import singleBetSlip from './SingleBetSlip.vue'
  //  import betslipMsg from './betslipMsg.vue'
  import betslipConfirm from './betslipConfirm.vue'
  import moneyInput from './moneyInput.vue'
  import preferenceSwitch from './preferenceSwitch.vue'
  import circleLoader from '@/components/common/CircleLoader'
  import circleLoaderWithCounter from '@/components/common/CircleLoaderWithCounter'
  import dotsLoader from '@/components/common/DotsLoader'
  import Icon from '@/components/common/Icon'
  import Screen from '@/components/mixins/Screen'
  import BettingOffer from '@/components/mixins/BettingOffer'

  import config from '@/config'
  //  import _ from 'lodash'

  export default {
    name: 'Betslip',

    components: {
      parlay,
      teaser,
      roundRobin,
      betSlipSelection,
      stakeInput,
      singleBetSlip,
      moneyInput,
      betslipConfirm,
      circleLoader,
      circleLoaderWithCounter,
      dotsLoader,
      preferenceSwitch,
      Icon
    },

    mixins: [
      Screen,
      BettingOffer
    ],

    data () {
      return {
        betslipActionsHeight: { },
        betSlipState: {
          0: 'Idle',
          0.5: 'Info',
          1: 'WaitingToConfirm',
          2: 'LiveCountDown',
          3: 'Spinner',
          4: 'InProgress',
          5: 'Attempted',
          6: 'Acceptable',
          7: 'Canceled',
          8: 'TimedOut',
          9: 'Error'
        },
        betSlipPlacementState: {
          1: 'acceptable', // ConfirmationRequired
          2: 'accepted',
          3: 'reOffered', // acceptable
          4: 'rejected',
          5: 'waiting'
        },
        stakeTZ: 0,
        winTZ: 0,
        winRR: 0,
        tab_: 'REGULAR',
        activeRR: {
          IDFOBetType: null,
          UnitCount: 0,
          PotentialReturn: 0
        },
        RRdetails: null,
        asking_price: 60000,
        down_payment: 20,
        multiSingles_: false,
        multiSinglesStake_: '',
        betTypeStakes_: {
          PerSelection: {},
          S: 0,
          PARLAY: 0,
          TEASER: 0,
          RR: 0
        },
        errorId: false,
        errorMsg: false,
        selectedTeaser: {},
        betsCnt: {
          REGULAR: 0,
          TEASER: 0,
          RR: 0
        },
        changed: false,
        changes: {
          price: [],
          currenthandicap: [],
          closed: [],
          suspended: [],
          upperband: [],
          lowerband: [],
          isclosed: 0,
          istradable: 0,
          interRelated: 0
        },
        showBetSlipChanged: false,
        showReceiptDetails: false,
        showError: false,
        noStakes: false,
        minValuesNotMet: false,
        maxValuesNotMet: false,
        minReturnNotMet: false,
        focus: [0],
        logOutTo: null,
        errorType: null,
        errors: {
          GEN: ['-20402', '-20403', '-20404', '-20405', '-20406', '-20407', '-20408', '-20409', '-20410', '-20420', '-20425', '-20426', '-20427', '-20428', '-20429', '-20430', '-20435', '-20436', '-20437', '-20439', '-20450', '-20453', '-20456', '-20457', '-20460', '-20461', '-20477', '-20478', '20205', 'Invalid selections count'],
          ARC: ['-20412', '-20413', '-20414', '-20415', '-20416', '-20417', '-20418', '-20419'],
          CUSTOM: {
            '-20700': false,
            '-20451': 'INSUFFICIENT_FUNDS',
            '-20455': 'INTERRELATED',
            '-20486': 'TRADING_LIMIT',
            '-20487': 'FINANCIAL_LIMIT',
            '-20488': 'INSUFFICIENT_FUNDS',
            '-20489': 'PLAYER_LOCKED',
            '-20490': 'PLAYER_SELFEXCLUDED',
            '-20491': 'SB_JURISDICTION_FAULT'
          },
          OTHER: ''
        },
        placeBetButtonVisibleTimeoutID: null
      }
    },

    props: [],

    computed: {
      externalUrls () {
        return config.externalUrls
      },
      inRefferal () {
        return store.getters['sbBetslipState/inRefferal']
        /*
        return this.betPlacementResult.result && this.betPlacementResult.result.Status &&
          this.betPlacementResult.result.Status.detailedStates &&
          this.betPlacementResult.result.Status.detailedStates.indexOf('referred') > -1
        */
      },
      path () {
        return this.$route.path
      },
      singleBetSlipSelection () {
        return store.getters['sbBetslipState/singleBetSlip']
      },
      closeFromParent () {
        return store.getters['sbBetslipState/closeFromParent']
      },
      dismissErrorFromSelection () {
        return store.getters['sbBetslipState/dismissErrorFromSelection']
      },
      minStake () {
        return store.getters['sbBetslipState/minStake']
      },
      maxStake () {
        return store.getters['sbBetslipState/maxStake']
      },
      maxTakeOut () {
        return store.getters['sbBetslipState/maxTakeOut']
      },
      slipTotalStakeMin () {
        return store.getters['sbBetslipState/slipTotalStakeMin']
      },
      slipTotalStakeMax () {
        return store.getters['sbBetslipState/slipTotalStakeMax']
      },
      slipTotalStakeMaxInPlay () {
        return store.getters['sbBetslipState/slipTotalStakeMaxInPlay']
      },
      confirmBetPlacement: {
        get: function () {
          return store.getters['sbBetslipState/confirmBetPlacement']
        },
        set: function (newVal) {
          // console.log('confirmBetPlacement newVal: ' + newVal)
          store.commit('sbBetslipState/setConfirmBetPlacement', newVal)
        }
      },
      showAcceptingChangesInfo: {
        get: function () {
          return store.getters['sbBetslipState/showAcceptingChangesInfo']
        },
        set: function (newVal) {
          // console.log('showAcceptingChangesInfo newVal: ' + newVal)
          store.commit('sbBetslipState/setShowAcceptingChangesInfo', newVal)
        }
      },
      mixedTeasers () {
        return store.getters['sbBetslipState/mixedTeasers']
      },
      teasers () {
        return store.getters['sbBetslipState/teasers']
      },
      teaserGroupsNo () {
        return store.getters['sbBetslipState/teaserGroupsNo']
      },
      teaserGroups () {
        return store.getters['sbBetslipState/teaserGroups']
      },

      dialogSingleBetslip () {
        return store.getters['overlayState/getSingleBetslipState']
      },

      /*
      dialogBetslipMsg () {
        return store.getters['overlayState/getBetslipMsg']
      },
      */

      dialogBetslipConfirm () {
        return store.getters['overlayState/getBetslipConfirm']
      },

      tab () {
        return store.getters['sbBetslipState/tab']
      },

      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      tnc4SB () {
        return store.getters['tncState/getSBtnc']
      },
      /*
      betTypeStakeSPARLAY () {
        return (1 * this.betTypeStakes.PARLAY + 1 * this.calculateTotalStake('S')).toFixed(2)
      },
      */
      winningsSING () {
        return this.winnings.S
      },
      multiSingles () {
        return false
//        return this.multiSinglesStake && !!this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType.C1
      },
      multiSinglesStake: {
        get: function () {
          return store.getters['sbBetslipState/multiSinglesStake']
        },
        set: function (newVal) {
          // console.log('multiSinglesStake newVal: ' + newVal)
          store.commit('sbBetslipState/setMultiSinglesStake', newVal)
        }
      },
      /*
      interRelated () {
        return store.getters['sbBetslipState/interRelated']
      },
      interRelatedLen () {
        return Object.keys(this.interRelated).length
      },
      */
      betTypeStakes () {
        return store.getters['sbBetslipState/betTypeStakes']
      },
      winnings () {
        return store.getters['sbBetslipState/returns']
      },
      gettingABTnR () {
        return store.getters['sbBetslipState/gettingABTnR']
      },
      betPlacementResult () {
        return store.getters['sbBetslipState/betPlacementResult']
      },
      betSlipStatus () {
        return store.getters['sbBetslipState/betSlipStatus']
      },
      gracePeriodTimedOut () {
        return store.getters['sbBetslipState/gracePeriodTimedOut']
      },
      liveSelections () {
        return store.getters['sbBetslipState/liveSelections']
      },
      isBetSlipLive () {
        return !!this.liveSelections.length
      },
      inRunningDelay () {
        return store.getters['sbBetslipState/inRunningDelay']
      },
      gracePeriod () {
        return store.getters['sbBetslipState/gracePeriod']
      },
      currentBetSlipState () {
        return store.getters['sbBetslipState/currentBetSlipState']
      },
      /*
      betslipSelections () {
        return store.getters['sbBetslipState/betslipSelections']
      },
      */
      betslipSelectionIds () {
        return store.getters['sbBetslipState/betslipSelectionIds']
      },
      betsNo () {
        return store.getters['sbBetslipState/selectionsNo']
      },
      allowedBetTypesAndReturnsCnt () {
        return store.getters['sbBetslipState/allowedBetTypesAndReturnsCnt']
      },
      allowedBetTypesAndReturns () {
        return store.getters['sbBetslipState/allowedBetTypesAndReturns']
      },
      allowedBetTypesSING () {
        return store.getters['sbBetslipState/allowedBetTypesSING']
      },
      allowedBetTypesPRL () {
        return store.getters['sbBetslipState/allowedBetTypesPRL']
      },
      allowedBetTypesPRLRR () {
        return store.getters['sbBetslipState/allowedBetTypesPRLRR']
      },
      allowedBetTypesRR () {
        return store.getters['sbBetslipState/allowedBetTypesRR']
      },
      showMultySingleWagerOption () {
        var show = this.allowedBetTypesSING &&
          this.allowedBetTypesSING[0] &&
          this.allowedBetTypesSING[0].IDFOBetType &&
          this.allowedBetTypesSING[0].IDFOBetType === 'C1'
//        console.log('show: ' + show)
        if (!show) {
          delete this.betTypeStakes.REGULAR.PerBetType.C1
          this.calculateWin()
        }
        return show
      },
      betSlipChanges () {
        return store.getters['sbBetslipState/betSlipChanges']
      },
      attemptedBetPotentialReturn () {
        var total = 0
        if (this.betPlacementResult && this.betPlacementResult.result && this.betPlacementResult.result.Bets && this.betPlacementResult.result.Bets.length) {
          for (var i = 0; i < this.betPlacementResult.result.Bets.length; i++) {
            total += this.betPlacementResult.result.Bets[i].PotentialReturn - this.betPlacementResult.result.Bets[i].TotalStake
          }
        }
        return total.toFixed(2)
      },
      allowedBetTypesAndReturns4T () {
        return store.getters['sbBetslipState/allowedBetTypesAndReturns4T']
      },
      betSlipChangeNo () {
        return store.getters['sbBetslipState/betSlipChangeNo']
      },
      teaserSports () {
        return store.getters['sbBetslipState/teaserSports']
      },
      isGeolocated () {
        var isGeolocated = store.getters['getGeolocated']
        return typeof isGeolocated !== 'undefined' ? JSON.parse(isGeolocated) : false
      },
      geolocationMessage () {
        // return Object.keys(store.getters['overlayState/getGeolocationMessage']).length > 0
        return store.getters['overlayState/getGeolocationMessage']
      },
      errorMsgLocalStorage () {
        return localStorage.getItem('geoError')
      },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      webViewAndMobile () {
        return store.getters['getWebViewAndMobile']
      },
      numberOfSucessfulyPlacedBets () {
        var bets = 0
        if (this.betPlacementResult && this.betPlacementResult.result && this.betPlacementResult.result.Bets && this.betPlacementResult.result.Bets.length) {
          for (var i = 0; i < this.betPlacementResult.result.Bets.length; i++) {
            if (this.betPlacementResult.result.Bets[i].TotalStake > 0) {
              bets++
            }
          }
        }
        return bets
      },
      state () {
        return window.ctsautoconf.STATE
      },
      isHardGeolocation () {
        return window.ctsautoconf.HARDGEOLOCATION
      },
      autoDismissBetSlip () {
        return store.getters['sbBetslipState/autoDismissBetSlip']
      }
    },

    methods: {
      saveToStorage () {
        store.dispatch('sbBetslipState/saveToStorage')
      },
      setBetSlipActionsheight () {
        var height
        if (!this.$refs.betActions || this.$refs.betActions.clientHeight === 0) {
          height = '176px'
        } else {
          height = this.$refs.betActions.clientHeight + 'px'
        }
        Vue.set(this.betslipActionsHeight, 'height', height)
      },
      setFocus (id, val) {
//        console.log('setFocus: ' + id + '; val: ' + val)
        if (val) {
          Vue.set(this.focus, 0, id)
        } else {
          if (this.focus[0] === id) {
            Vue.set(this.focus, 0, 0)
          }
        }
      },
      killFocus (id) {
        this.focus[id] = !true
      },
      closeBetslipDialog () {
        store.commit('sbBetslipState/setActiveBetSlip', false)
        store.dispatch('overlayState/deactivateBetslip')
      },
      liveBetNow () {
        var liveEventsNumber = (this.liveEvents && this.liveEvents.length) || 0
//        console.log('liveBetNow: ' + liveEventsNumber)
        if (liveEventsNumber) {
//          this.$router.push({path: '/live' || '/'})
          this.$router.push({path: '/sports' || '/'})
        } else {
          this.$router.push({path: '/sports' || '/'})
        }
      },
      disablePlaceBet () {
        var disabled = this.gettingABTnR ||
          this.showBetSlipChanged ||
//          (this.showBetSlipChanged && !this.showError) ||
          this.showError ||
          // parseFloat(this.betTypeStakes.PerTab[this.tab]) <= 0 ||
          // this.minValuesNotMet ||
          false
        //
//        console.log('disablePlaceBet: ' + disabled)
        var reason = []
        if (this.gettingABTnR) {
          reason.push('gettingABTnR')
        }
        if (this.showBetSlipChanged) {
          reason.push('BetSlipChanged')
        }
        if (this.showError) {
          reason.push('showError')
        }

        if (!this.isOpenedFromWebView && !this.webViewAndMobile) {
          if (this.isGeolocated) {
            return disabled ? reason.join('_') : disabled
          } else {
            return 'notGeoLocated'
          }
        }
      },
      setTabFromBetSlip (tab) {
//        console.log('setTabFromBetSlip: ' + tab)
        this.dismissBetSlip(0, 0, 0, tab)
        this.$emit('setTabFromBetSlip', tab)
      },
      getSelectionDataById (id) {
//        console.log('getSelectionDataById')
        var selection = store.getters['sbBetslipState/getStoredSelectionById'](id)
        var market = store.getters['sbBetslipState/getStoredMarketById'](id)
//        console.log(selection)
        return [{selection: selection, market: market}]
      },
      formatHandicap (selection) {
        var h = selection.currenthandicap && !isNaN(selection.currenthandicap) ? parseFloat(selection.currenthandicap) : ''
        if (h) {
          if (selection.hadvalue === 'D' || selection.hadvalue === 'A') {
            if (h) {
              h *= -1
            }
          }
          if (selection.hadvalue === 'H' || selection.hadvalue === 'D' || selection.hadvalue === 'A') {
            if (h > 0) {
              h = '+' + h
            }
          }
        }
        return h
      },
      formatSelectionName (selection) {
        return Array.isArray(selection.name) ? selection.name[0] : selection.name
      },
      betSlipRef (betPlacementResult) {
        /*
        var ref = []
        var i
        for (i = 0; i < betPlacementResult.Bets.length; i++) {
          ref.push(betPlacementResult.Bets[i].ExternalReference)
        }
        return betPlacementResult.ExternalReference + ' / ' + ref.join(', ')
        */
        return betPlacementResult.ExternalReference || ''
      },
      betTypeRef (bet) {
        return this.betPlacementResult.result.ExternalReference + ' / ' + bet.ExternalReference
      },
      checkLive (selection) {
        return this.liveSelections.indexOf(selection) >= 0
      },
      setTeaserType (t) {
        // console.log('setTeaserType: ' + t)
        this.selectedTeaser = t
      },
      openDialogSingleBetSlip () {
        // console.log('openDialogSingleBetSlip ')
        store.dispatch('overlayState/activateSingleBetslip')
      },

      setCurrentBetSlipState (s) {
        store.commit('sbBetslipState/setCurrentBetSlipState', s)
      },

      formatOdds (odds) {
        return priceFormat.formatOdds(odds)
      },
      formatOddsFromReturn (bet) {
        var odds
        odds = bet.price || ((bet.PotentialReturn - bet.TotalStake) / bet.WinStake + 1)
        odds = priceFormat.formatOdds(odds, 0)
        return odds
      },
      calculateWin (bt, obj) {
//        console.log('calculateWin')
        var self = this
        var win
        var t
        var stake
        var noStakes = true
        var minValues = false
        var maxValues = false
        var minReturn = false
        var totalStake
//        var sport
        var srcABTnR
        bt = bt || this.tab
        var skip = !true
        var betsCnt = {
          REGULAR: 0,
          TEASER: 0,
          RR: 0
        }
        var stakeNum = function (s) {
          if (typeof s === 'string') {
            s = parseFloat(s)
          }
          return s ? s.toFixed(2) * 1 : s
        }
        if (this.gettingABTnR || skip) {
          return null
        }
        //
        if (this.tab === 'REGULAR') {
          this.betTypeStakes.PerTab.REGULAR = 0
          this.winnings.PerTab.REGULAR = 0
          //
          for (t in this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType) {
            stake = this.betTypeStakes.REGULAR.PerBetType[t]
            stake = stakeNum(stake)
            if (stake) {
              noStakes = false
              totalStake = (this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType[t].UnitCount || 0) * stake
              win = (this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType[t].PotentialReturn || 0) * stake
              win = this.winnings.REGULAR.PerBetType[t] * 1
              if (win > 0) {
                betsCnt.REGULAR++
              }
              if (stake < this.minStake.PerBetType) {
                minValues = true
              }
              if (parseFloat(win.toFixed(2)) === 0) {
                minReturn = true
              }
              if (stake > this.maxStake.PerBetType) {
                maxValues = true
              }
            } else {
              totalStake = 0
              win = null
            }
            win = win ? win.toFixed(2) : win
//            Vue.set(this.winnings.REGULAR.PerBetType, t, win)

            this.winnings.PerTab.REGULAR += win ? 1 * win : 0
            this.betTypeStakes.PerTab.REGULAR += totalStake || 0
          }

          for (t in this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerSelection) {
            stake = this.betTypeStakes.REGULAR.PerSelection[t]
            stake = stakeNum(stake)
            if (stake) {
              noStakes = false
              totalStake = 1 * stake
              win = this.winnings.REGULAR.PerSelection[t] * 1
              if (win > 0) {
                betsCnt.REGULAR++
              }
              //
              if (stake < this.minStake.PerSelection) {
                minValues = true
              }
              if (parseFloat(win.toFixed(2)) === 0) {
                minReturn = true
              }
              if (stake > this.maxStake.PerSelection) {
                maxValues = true
              }
            } else {
              totalStake = 0
              win = null
            }
            win = win ? win.toFixed(2) : win
            if (!this.multiSingles) {
              this.winnings.PerTab.REGULAR += win ? 1 * win : 0
              this.betTypeStakes.PerTab.REGULAR += totalStake || 0
            }
          }
          //
          this.betTypeStakes.PerTab.REGULAR = this.betTypeStakes.PerTab.REGULAR.toFixed(2)
          this.winnings.PerTab.REGULAR = this.winnings.PerTab.REGULAR.toFixed(2)
          //
          this.betsCnt.REGULAR = betsCnt.REGULAR
        }

        if (this.tab === 'RR') {
          this.betTypeStakes.PerTab.RR = 0
          this.winnings.PerTab.RR = 0
          //
          for (t in this.allowedBetTypesAndReturns.RR.PotentialReturns.PerBetType) {
            stake = this.betTypeStakes.RR.PerBetType[t]
            stake = stakeNum(stake)
            if (stake) {
              noStakes = false
              totalStake = (this.allowedBetTypesAndReturns.RR.PotentialReturns.PerBetType[t].UnitCount || 0) * stake
              win = this.winnings.RR.PerBetType[t] * 1
              if (win > 0) {
                betsCnt.RR++
              }
              //
              if (stake < this.minStake.PerBetType) {
                minValues = true
              }
              if (parseFloat(win.toFixed(2)) === 0) {
                minReturn = true
              }
              if (stake > this.maxStake.PerBetType) {
                maxValues = true
              }
            } else {
              totalStake = 0
              win = null
            }
            win = win ? win.toFixed(2) : win

            this.winnings.PerTab.RR += win ? 1 * win : 0
            this.betTypeStakes.PerTab.RR += totalStake || 0
          }
          //
          this.betTypeStakes.PerTab.RR = this.betTypeStakes.PerTab.RR.toFixed(2)
          this.winnings.PerTab.RR = this.winnings.PerTab.RR.toFixed(2)
          //
          this.betsCnt.RR = betsCnt.RR
        }

        if (this.tab === 'TEASER') {
          let teaserSports = self.teaserSports
          if (self.mixedTeasers) {
            teaserSports = ['MIXED']
          }
          //
          this.betTypeStakes.PerTab.TEASER = 0
          this.winnings.PerTab.TEASER = 0
          //
//          var sports = ['NFL', 'BASKETBALL']
          var teaserSource = self.mixedTeasers ? teaserSports.length : self.teaserGroupsNo
          // this.teaserSports.forEach(function (sport) {
//          for (var tg = 0; tg < this.teaserGroupsNo; tg++) {
//            var sport = tg
          for (var tg = 0; tg < teaserSource; tg++) {
            var sport = self.mixedTeasers ? teaserSports[tg] : tg
//            var group = this.teaserGroups[tg]
//            sport = store.getters['sbBetslipState/teaserGroupId'](group)
//            console.log('Calculation Teaser sport: ' + sport)
            //
            srcABTnR = self.allowedBetTypesAndReturns.TEASER[sport]
            for (t in srcABTnR.PotentialReturns.PerBetType) {
              stake = self.betTypeStakes.TEASER[sport].PerBetType[t]
              stake = stakeNum(stake)
              if (stake) {
                noStakes = false
                totalStake = (srcABTnR.PotentialReturns.PerBetType[t].UnitCount || 0) * stake
                win = self.winnings.TEASER[sport].PerBetType[t] * 1
                if (win > 0) {
                  betsCnt.TEASER++
                }
                //
                if (stake < self.minStake.PerBetType) {
                  minValues = true
                }
                if (parseFloat(win.toFixed(2)) === 0) {
                  minReturn = true
                }
                if (stake > self.maxStake.PerBetType) {
                  maxValues = true
                }
              } else {
                totalStake = 0
                win = null
              }
              win = win ? win.toFixed(2) : win

              self.winnings.PerTab.TEASER += win ? 1 * win : 0
              self.betTypeStakes.PerTab.TEASER += totalStake || 0
            }
          }
          //
          this.betTypeStakes.PerTab.TEASER = this.betTypeStakes.PerTab.TEASER.toFixed(2)
          this.winnings.PerTab.TEASER = this.winnings.PerTab.TEASER.toFixed(2)
          //
          this.betsCnt.TEASER = betsCnt.TEASER
        }
        Vue.set(this, 'minValuesNotMet', minValues)
        Vue.set(this, 'maxValuesNotMet', maxValues)
        Vue.set(this, 'minReturnNotMet', minReturn)
        Vue.set(this, 'noStakes', noStakes)
      },

      removeSelection (s) {
        // console.log('removeSelection:')
        // console.log(s)
        store.dispatch('sbBetslipState/toggleBetslipSelection', [s]).then(
          function () {
//            self.showInfoMsg()
          }
        )
      },
      setTab (tab) {
        if (this.currentBetSlipState) {
          return
        }
        this.userTab = tab
        store.commit('sbBetslipState/setTab', tab)
        this.dismissBetSlip(null, !true)
      },
      clearAll () {
        if (this.currentBetSlipState) {
          return
        }
        this.multiSinglesStake = ''
//        this.multiSingles = false
        this.activeRR = {
          IDFOBetType: null,
          UnitCount: 0,
          PotentialReturn: 0
        }
        store.dispatch('sbBetslipState/clearBetSlip')
        store.dispatch('sbBetslipState/resetBetSlipChanges')
        this.setTab('REGULAR')
      },
      clearStakesAndReturns () {
        this.multiSinglesStake = ''
        store.dispatch('sbBetslipState/clearStakesAndReturns')
      },
      initPlaceBet (bt) {
        var data = this.betSlipPlacementData()
        if (this.webViewAndMobile) {
          store.commit('overlayState/setMessageDialogMsg', {reason: 'native-app', persistent: true})
          store.dispatch('overlayState/activateMessageDialog')
        } else if (!this.isGeolocated && this.isOpenedFromWebView) {
          store.commit('overlayState/setMessageDialogMsg', {reason: 'native-failed-geolocation', persistent: true, fullscreen: false})
          store.dispatch('overlayState/activateMessageDialog')
        } else {
          this.checkBetSlip(data)
        }
      },
      placeBet (bt) {
        this.startBetSlipPlacement()
      },
      updateStake (v) {
        // console.log('updateStake: ' + v)
      },
      updateStakeSING (win) {
        // console.log('updateStakeSING: ' + win)
        var t = this.allowedBetTypesSING && this.allowedBetTypesSING[0] && this.allowedBetTypesSING[0].IDFOBetType
        // console.log(t)
        var stake = win
        stake = win / (this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType[t].PotentialReturn - 1)
        stake = stake.toFixed(2)
        // console.log('stake: ' + stake)
        this.betTypeStakes.S = stake
      },
      betSlipPlacementData () {
//        console.log('betSlipPlacementData')
        // REGULAR
        // this.multiSingles
        var selectedTeaser = {}
        var b
        var betTypes = []
        var betType = 'S'
        if (this.tab === 'S' || this.tab === 'REGULAR') {
          betType = (this.multiSingles && this.allowedBetTypesSING[0]) || {IDFOBetType: 'S'}
          betTypes.push(betType)
          if (this.allowedBetTypesPRL && this.allowedBetTypesPRL[0]) {
            betTypes.push(this.allowedBetTypesPRL[0])
          }
        }

        if (this.tab === 'TEASER') {
          var hasTeaser = false
          selectedTeaser = {}
          //
          if (this.mixedTeasers) {
            if ((this.allowedBetTypesAndReturns.TEASER.NFL && this.allowedBetTypesAndReturns.TEASER.NFL.AllowedBetTypes && this.allowedBetTypesAndReturns.TEASER.NFL.AllowedBetTypes.length) ||
              (this.allowedBetTypesAndReturns.TEASER.BASKETBALL && this.allowedBetTypesAndReturns.TEASER.BASKETBALL.AllowedBetTypes && this.allowedBetTypesAndReturns.TEASER.BASKETBALL.AllowedBetTypes.length) ||
              (this.mixedTeasers && this.allowedBetTypesAndReturns.TEASER.MIXED && this.allowedBetTypesAndReturns.TEASER.MIXED.AllowedBetTypes && this.allowedBetTypesAndReturns.TEASER.MIXED.AllowedBetTypes.length)) {
              betType = {IDFOBetType: 'A'}
              betTypes.push(betType)
              hasTeaser = true
            }
            selectedTeaser = {
              BASKETBALL: this.betTypeStakes.TEASER.BASKETBALL.PerBetType.A && this.selectedTeaser.BASKETBALL,
              NFL: this.betTypeStakes.TEASER.NFL.PerBetType.A && this.selectedTeaser.NFL,
              MIXED: this.betTypeStakes.TEASER.MIXED.PerBetType.A && this.selectedTeaser.MIXED
            }
          } else {
            for (var i = 0; i < 8; i++) {
              var test = this.allowedBetTypesAndReturns.TEASER[i] && this.allowedBetTypesAndReturns.TEASER[i].AllowedBetTypes && this.allowedBetTypesAndReturns.TEASER[i].AllowedBetTypes.length
              if (test) {
                hasTeaser = true
                selectedTeaser[i] = this.selectedTeaser[i]
              }
            }
            if (hasTeaser) {
              betType = {IDFOBetType: 'A'}
              betTypes.push(betType)
            }
          }
        }

        if (this.tab === 'RR') {
          for (b = 0; b < this.allowedBetTypesRR.length; b++) {
            betType = this.allowedBetTypesRR[b]
            betTypes.push(betType)
          }
          //
          if (this.allowedBetTypesPRLRR && this.allowedBetTypesPRLRR[0]) {
            betTypes.push(this.allowedBetTypesPRLRR[0])
          }
        }

        var data = {
          id: betTypes,
          tab: this.tab,
          betTypeStakes: this.betTypeStakes,
          multiSingles: this.multiSingles,
          selectedTeaser: selectedTeaser,

          noStakes: this.noStakes,
          minValuesNotMet: this.minValuesNotMet,
          maxValuesNotMet: this.maxValuesNotMet,
          minReturnNotMet: this.minReturnNotMet,
          winnings: this.winnings.PerTab
        }
        return data
      },

      cancelBet () {
        this.setCurrentBetSlipState(0)
      },

      checkBetSlip (data) {
        var self = this
        store.commit('sbBetslipState/clearAttemptedBetSlip')
        store.commit('sbBetslipState/setBetSlipStatus', {})
        store.commit('sbBetslipState/setBetPlacementResult', {})
        store.dispatch('sbBetslipState/betSlipChecks', data).then(
          function () {
            if (self.confirmBetPlacement) {
              self.setCurrentBetSlipState(1)
            } else {
              self.startBetSlipPlacement()
            }
          }
        ).catch(function (errors) {
          self.errorId = errors[0]
          self.errorMsg = self.$t('BetSlip.placement.error.' + errors[0])
          self.showError = true
        })

        if (!this.mobileBigAndBelow) {
          this.keepPlaceBetButtonVisible()
        }
      },

      handleBetPlacementErrorData (r) {
//        console.log('handleBetPlacementErrorData')
        var self = this
        var errorId = false
        //
        if (r && r.exceptionType) {
          if (r.exceptionType === 'Com.Finsoft.Warp.Connecticut.SessionTimeoutException' ||
            r.exceptionType === 'Com.Finsoft.Warp.Connecticut.Services.UserNotLoggedInException' ||
            // r.exceptionType.indexOf('System.ServiceModel.FaultException') > -1 ||
            r.exceptionType === 'isLoggedOut') {
            errorId = 'SESSION_TIMEDOUT'
            clearTimeout(self.logOutTo)
            self.logOutTo = setTimeout(self.logOut, 1 * 1000)
          } else if (r.exceptionType.indexOf('System.ServiceModel.FaultException') > -1) {
            self.errors.OTHER = r.message
          }
        }

        if (self.betSlipStatus && (self.betSlipStatus.StatusText || self.betSlipStatus.StatusCode)) {
          var errT = this.checkErrorType()
          if (self.betSlipStatus.StatusText) {
            if (self.betSlipStatus.StatusText.indexOf('Invalid selections count') !== -1) {
              errT = 'GEN'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-') !== -1) {
              errorId = 'UNKNOWN'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-0002020088]') !== -1) {
              // [MMaker-0002020088] Internal service fault [LOG ID:51632351]
              errorId = 'UNKNOWN'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-0002110088]') !== -1) {
              errorId = 'SESSION_TIMEDOUT'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-0002130088]') !== -1) {
              errorId = 'WAGER_LIMIT'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-0002090088]') !== -1) {
              errorId = 'TIME_LIMIT'
            }
            if ((self.betSlipStatus.StatusText && (self.betSlipStatus.StatusText.indexOf('[MMaker-0002190088]') !== -1 ||
              self.betSlipStatus.StatusText.indexOf('0002190088') !== -1 ||
              self.betSlipStatus.StatusText.indexOf('-20700') !== -1)) ||
              (self.betSlipStatus.StatusCode && self.betSlipStatus.StatusCode.indexOf('-20700') !== -1)) {
              // TODO
              errorId = 'DEPOSIT_THRESHOLD'
              errT = false
            }
          }
        }
        if (errorId) {
          self.errorId = errorId
          // self.errorMsg = self.$gettext('BetSlip.placement.error.' + self.errorId)
          // self.errorMsg = self.$gettextInterpolate(self.errorMsg, {uiView: self.isOpenedFromWebView ? '?uiView=true' : ''})
          self.errorMsg = self.$t('BetSlip.placement.error.' + self.errorId, {uiView: self.isOpenedFromWebView ? '?uiView=true' : ''})
          self.betSlipStatus.StatusText = self.errorMsg
        }
        if (errT) {
          self.errorId = errT
          self.errorType = errT
          // self.errorMsg = self.$gettext('BetSlip.placement.error.' + self.errorId + '.reason')
          // self.errorMsg = self.$gettextInterpolate(self.errorMsg, {uiView: self.isOpenedFromWebView ? '?uiView=true' : ''})
          self.errorMsg = self.$t('BetSlip.placement.error.' + self.errorId + '.reason', {uiView: self.isOpenedFromWebView ? '?uiView=true' : ''})
          self.betSlipStatus.StatusText = self.errorMsg
        }
      },

      checkErrorType (status) {
        var self = this
        var errT = null
        var codes = self.betSlipStatus.StatusCode ? self.betSlipStatus.StatusCode.split(/[, ]+/) : []
        if (codes.length) {
          codes.forEach(function (code) {
            if (self.errors.GEN.indexOf(code) > -1) {
              errT = errT || 'GEN'
            } else if (self.errors.ARC.indexOf(code) > -1) {
              errT = errT || 'ARC'
            } else if (self.errors.CUSTOM[code]) {
              errT = self.errors.CUSTOM[code]
            }
          })
        }
        return errT
      },

      startBetSlipPlacement () {
        // console.log('StartBetSlipPlacement')
        var self = this
        var data = this.betSlipPlacementData()
        //
        store.dispatch('sbBetslipState/startBetSlipPlacement', data).then(function (r) {
          self.handleBetPlacementErrorData(r)
        }).catch(function (error) {
          console.log('error in bet startBetSlipPlacement')
          console.log(error)
        })
      },

      getBetSlipStatus () {
        var IDFOBetSlip = this.betPlacementResult.result.IDFOBetSlip
        store.dispatch('sbBetslipState/getBetSlipStatus', IDFOBetSlip)
      },

      popLogIn () {
        store.dispatch('overlayState/activateLoginDialog')
      },

      logOut () {
        console.log('dispatch LogOut from BetSlip')
        clearTimeout(this.logOutTo)
        if (this.isLoggedIn) {
          store.dispatch('logout')
        }
      },

      handleBetPlacementError () {
        // console.log('handleBetPlacementError: ' + this.errorId)
        switch (this.errorId) {
          case 'RECONFIRM_TNC_SB':
            store.dispatch('tncState/confirmTsAndCs4Area').then().catch(
              function (error) {
                console.log('confirmTsAndCs4Area error')
                console.log(error)
              }
            )
            break
          case 'NOT_LOGGED_IN':
            this.popLogIn()
            break
          case 'SESSION_TIMEDOUT':
            this.logOut()
            break
        }
        this.errorMsg = false
        this.errorId = false
      },

      dismissWarning () {
        this.showError = false
        this.setCurrentBetSlipState(0)
      },

      dismissBetSlip (retain, skipResetChanges, updateBetSlip, goToHistory) {
//        console.log('betslip.vue: dismissBetSlip')
//        console.log('this.betSlipStatus.State: ' + this.betSlipStatus.State)
        if (skipResetChanges && !this.showError) {
          // console.log('Nothing to dismiss!!!')
          return
        }
        store.commit('sbBetslipState/setAutoDismissBetSlip', false)
        //
        var isFastBet = !!this.singleBetSlipSelection.idfoselection
        this.errorType = null
        this.showError = false
        this.setCurrentBetSlipState(0)
        this.handleBetPlacementError()
        var shouldClearAll = !retain && this.betSlipStatus.State === 2
        //
        if (updateBetSlip || this.betSlipStatus.State === 4 || (this.betSlipStatus.State === 2 && retain)) {
          var self = this
//          console.log('betslip.vue: dismissBetSlip -> updateBetSlip')
          store.dispatch('sbBetslipState/updateBetSlip', true).then(function (r) {
            // console.log('sbBetslipState/updateBetSlip:')
            // console.log(r)
            if (self.tab === 'TEASER') {
              store.dispatch('sbBetslipState/updateTeaser')
            }
          })
        }
        //
        store.commit('sbBetslipState/setInRefferal', false)
        store.commit('sbBetslipState/setBetSlipStatus', {})
        store.commit('sbBetslipState/setBetPlacementResult', {})
        if (retain && !isFastBet) {
          this.clearStakesAndReturns()
        }
        if (!skipResetChanges) {
          store.dispatch('sbBetslipState/resetBetSlipChanges')
        }
        if (!isFastBet && shouldClearAll) {
          this.clearAll()
          if (this.mobileBigAndBelow && !goToHistory) {
            this.closeBetslipDialog()
          }
        } else {
        }
        //
        store.commit('sbBetslipState/clearSingleBetSlip')
      },

      confirmBetSlip () {
        // console.log('@btn click confirmBetSlip')
        var self = this
        store.dispatch('sbBetslipState/confirmBetSlip').then(function (r) {
          self.handleBetPlacementErrorData(r)
        })
      },

      rejectBetSlip () {
        var self = this
        // console.log('@btn click rejectBetSlip')
        store.dispatch('sbBetslipState/rejectBetSlip').then(function (r) {
          self.handleBetPlacementErrorData(r)
        })
      },
      updateSinglesStake () {
//        console.log('updateSinglesStake')
//        if (this.multiSinglesStake) {
        for (var s in this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerSelection) {
          // console.log('s: ' + s)
//          this.betTypeStakes.REGULAR.PerSelection[s] = this.multiSinglesStake
          Vue.set(this.betTypeStakes.REGULAR.PerSelection, s, this.multiSinglesStake)
        }
//        }
      },
      handleLogIn (isLoggedIn) {
//        console.log('watch isLoggedIn: ' + isLoggedIn)
        if (isLoggedIn) {
          store.dispatch('tncState/is2ReconfirmTsAndCs4Area')
        } else {
          store.dispatch('tncState/onLogout')
          this.dismissBetSlip(true)
        }
      },
      clone (obj) {
        return JSON.parse(JSON.stringify(obj))
      },
      acceptChanges () {
//        console.log('betslip.vue: acceptChanges')
        var self = this
        store.dispatch('sbBetslipState/resetBetSlipChanges').then(
          function () {
            self.changed = false
            self.changes = {
              price: [],
              currenthandicap: [],
              closed: [],
              suspended: [],
              upperband: [],
              lowerband: [],
              isclosed: 0,
              istradable: 0,
              interRelated: 0
            }
            //
            store.dispatch('sbBetslipState/updateBetSlip', !true)
          }
        )
        // this.setCurrentBetSlipState(0)
        this.showBetSlipChanged = false
      },
      isEqual (a, b) {
//        console.log('compare')
//        console.log(a)
//        console.log(b)
        var result = a.length === b.length && a.every(function (e) {
          return b.indexOf(e) > -1
        })
//        console.log('compare result: ' + result)
        return result
      },

      goToDeposit () {
        // console.log('goToDeposit')
      },
      updateSelected (id) {
//        console.log('updateSelected: ' + id)
        var self = this
        if (this.errorId === 'NO_BET_TYPES' || this.errorId === 'NO_STAKES') {
          this.dismissBetSlip(null, true)
          return
        }
        //
        var selections = store.getters['sbBetslipState/betslipSelections']
        var nonAvailableForBetting = selections.filter(function (s) {
          return (s.isclosed || !s.istradable) &&
            ((self.tab === 'REGULAR' && self.betTypeStakes.REGULAR.PerSelection[s.idfoselection]) ||
            (self.tab !== 'REGULAR' && store.getters['sbBetslipState/isOptedIn']({tab: self.tab, id: s.idfoselection})))
        }).length
//        console.log('nonAvailableForBetting: ' + nonAvailableForBetting)
        if (!nonAvailableForBetting && this.errorId === 'CLOSED_or_SUSPENDED') {
          this.dismissBetSlip(null, true)
        }
      },
      keepPlaceBetButtonVisible () {
        var placeBetButton = this.$refs.betActions
        var top = placeBetButton.getBoundingClientRect().top

        clearTimeout(this.placeBetButtonVisibleTimeoutID)

        this.placeBetButtonVisibleTimeoutID = setTimeout(() => {
          window.scrollTo(0, placeBetButton.offsetTop - top)
        }, 50)
      }
    },

    watch: {
      /*
      path (newVal) {
//        console.log('New path: ' + newVal)
//        if (!this.mobileBigAndBelow && !this.isOpenedFromWebView && !this.webViewAndMobile) {
        if (!this.mobileBigAndBelow) {
          if (newVal.indexOf('/sports') > -1) {
//            console.log('path dispatch updateBetSlip')
            // store.dispatch('sbBetslipState/updateBetSlip')
          }
        }
      },
      */

      betSlipStatus () {
        if (!this.mobileBigAndBelow && this.betSlipStatus.State === 2) {
          window.scrollTo(0, 0)
        }
      },
      dismissErrorFromSelection () {
        this.dismissBetSlip(null, true)
      },
      isLoggedIn (newVal, oldVal) {
        // console.log('Watch isLoggedIn: ' + newVal + ' / ' + oldVal)
        this.handleLogIn(newVal)
      },

      multiSinglesStake (newVal, oldVal) {
        // console.log('multiSinglesStake changed from: ' + oldVal + ' to: ' + newVal)
        // console.log('type: ' + typeof newVal)
        if (newVal === '' || typeof newVal === 'undefined' || (newVal && parseFloat(newVal) < 0)) {
//          this.multiSingles = false
        } else {
//          this.multiSingles = true
          this.updateSinglesStake()
        }
      },

      betsNo (newVal) {
//        console.log('betsNo: ' + newVal)
        this.dismissBetSlip()
        if (!newVal) {
          this.clearStakesAndReturns()
        } else {
          this.updateSelected()
          store.dispatch('sbBetslipState/scheduleBetSlipUpdate', 1)
        }
      },

      betSlipChangeNo (newVal) {
        var keys = ['closed', 'suspended', 'price', 'currenthandicap', 'NR']
        var len = 0
        if (this.currentBetSlipState < 2) {
          for (var i = 0; i < keys.length; i++) {
            len += this.betSlipChanges[keys[i]].length
          }
          if (newVal && len) {
//            this.setCurrentBetSlipState(0.5)
            this.showBetSlipChanged = true
          } else {
            this.showBetSlipChanged = false
          }
        }
        if (this.currentBetSlipState === 0.5 && (!newVal || !len)) {
          this.setCurrentBetSlipState(0)
        }
      },

      closeFromParent (newVal) {
//        console.log('closeFromParent: ' + this.closeFromParent)
        if (newVal && (this.betSlipStatus.State === 2 || this.betSlipStatus.State === 4 || this.currentBetSlipState >= 7)) {
          this.dismissBetSlip()
        }
        setTimeout(function () {
          store.commit('sbBetslipState/setCloseFromParent', false)
        }, 0)
      },

      autoDismissBetSlip (newVal) {
//        console.log('Watch autoDismissBetSlip: ' + newVal)
        if (newVal) {
          var retain = newVal === 1
          this.dismissBetSlip(retain)
        }
      }
    },

    created () {
//      console.log('Created BetSlip')
      var self = this
      setTimeout(function () {
        self.handleLogIn(self.isLoggedIn)
      }, 0)
      //
    },
    mounted () {
      // console.log('Mounted BetSlip')
      this.setBetSlipActionsheight()
      setTimeout(function () {
        store.dispatch('sbBetslipState/getFromStorage')
      }, 1000)
    },
    updated () {
      this.setBetSlipActionsheight()
    }
  }
</script>

<style lang="stylus" scoped>
@import "~@/css/config"

  .SBbetSlip {
    .tabs {
      width: 100%;
      text-align: center;
      .tab {
        cursor: pointer;
      }
    }
  }
  .SBbetSlip
     @media tablet-and-above
       padding: 0 4px

  @media tablet-and-below
    .action-msg
    .betPlacement
      height: -moz-calc(100% - 100px) !important /* Firefox */
      height: -webkit-calc(100% - 100px) !important /* Chrome, Safari */
      height: calc(100% - 100px)  !important /* IE9+ and future browsers */
    .SBbetSlip
      height: 100%!important /* Firefox */
      height: 100%!important /* Chrome, Safari */
      height: 100%!important /* IE9+ and future browsers */
      margin: 0px!important
      .browser-safari.os-ios &
        height: 100% !important
        margin: 0px!important
  @media tablet-and-above
    .fixed_footer_sep
      display: none

  .fixed_footer_sep.bet_placed
      display: none !important

  .errorMsg {
    position: relative;
    border-radius: 4px 4px 0 0;
    background-color: #FEF5F5;
    background-color: #DB3F3F;
    color: #fff;
    text-align: left;
    font-weight: normal;
    padding: 10px 10px;
    margin: -12px -12px 12px -12px;

    &.HAS_ERRORS{
      background-color: #DB3F3F;
      color: #fff;
    }
    &.NO_STAKES,
    &.NO_BET_TYPES,
    &.NO_LIVE_TEASERS_ALLOWED {
      background-color: #1493FF;
    }
  }

  @media tablet-and-below
    .errorMsg
      border-radius: 0px;

  .empty-betslip {
    text-align: center;
  }

  .float-right {
    float: right;
  }

  .align-center {
    text-align: center;
  }

  .action-btns {
    padding: 12px;
    background-color: #fff;
    button:disabled {
      opacity: 0.6;
    }
  }
  .betslip_actions:not(.bet_placed) {
    // margin-top: 10px;
    @media tablet-and-below {
      position: fixed;
      bottom: 0px;
      left: 0;
      right: 0;

      .browser-safari.os-ios & {
        position: sticky;
        position: -webkit-sticky;
        bottom: 0px;
        margin: 0 -4px 0px -4px;
        top:100%;
      }
    }
  }

  .betslip_actions.bet_placed .action-btns {
    @media tablet-and-below {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  .action-btns.Error {
    padding: 0 12px 12px 12px;
    background-color: #fff;
  }
  .action-btns.Error {
    padding: 0 12px 12px 12px;
    background-color: #fff;
    .secondary{
      background: #2a77aa  !important
    }
  }

  .odds-line,
  .stake-line,
  .total-stake-line,
  .win-line {
    clear: both;
    padding: 5px 5px;
    text-align: right;

    .label {
      float: left;
    }
    input {
      background-color: white;
      text-align: center;
    }
  }

  .S {
    .odds-line {
      background-color: #9e864d;
      color: white;
      padding: 5px;
    }
    .stake-line {
      background-color: #DDD;
      color: black;
    }
    .total-stake-line {
      background-color: #CCC;
      color: black;
    }
    .win-line {
      background-color: #BBB;
      color: black;
    }
  }

  .REGULAR {
    .odds-line {
      background-color: #9e864d;
      color: white;
      padding: 5px;
    }
    .stake-line {
      background-color: #DDD;
      color: black;
    }
    .win-line,
    .total-stake-line {
      background-color: #CCC;
      color: black;
    }
  }

  .header-SING {
    display: flex;
    flex-basis: auto;
    align-items: center;
    padding: 8px 0 0 0
    h2 {
      font-size: 16px;
      font-weight: bold;
    }
    .wagerAllSinglesContainer,
    h2 {
      flex: 1 auto;
      flex-basis: auto;
      min-height: auto !important
    }
  }
  .wagerAllSinglesContainer {
    text-align: right;
    white-space: nowrap;
  }
  .wagerAllSinglesContainer.hidden {
    display: none;
  }

  .wagerAllSinglesContainer{
    >>>.clear-btn{
      bottom: 9px !important;
    }
  }

  .wagerAllSinglesContainer
    >>>.money-input.input-only.focused
    >>>.money-input.input-only.non-empty
      padding: 0px
      top:17px
      input
        min-width: 168px !important
        height: 50px
      .currency
        bottom: 6px
  .wagerAllSinglesContainer
    >>>.money-input.input-only:not(.focused):not(.non-empty)
      label
        font-size: 14px
        font-weight: bold
        top: 5px

  .header-SING.focused
  .header-SING.non-empty
    margin-top: -2px !important
    padding-top: 0 !important
    margin-bottom: 25px

  .betPlacement{
    padding: 10px;
  }

    .btn-label {
      line-height: 1.3;
      .line1 {
        font-size: 16px;
      }
      .line2 {
        font-size: 12px;
        opacity: 0.8;
      }
    }
  button .loader-container {
    position: absolute;
    right: 10px;
    top: 10px;
    .loader {
      border-width: 3px;
      border-top-width: 3px;
      border-top-color: #888888;
      width: 12px;
      height: 12px;
    }
  }
  .not-geolocated {
    p {
      margin: 0px;
    }
    .verify {
      font-size: 12px;
      margin: 0px;
      }
    .pls-wait {
      margin: 0;
      color: #1F375B;
      text-transform: uppercase;
      font-size: 16px;
      font-weight: bold;
      font-weight: bold;
      line-height: 35px;
      text-align: center;
      height: 22px;
      margin-bottom: 5px;
  }
    text-align: center;
  }

  .betPlacement.bet_placed
    background: #fff
    padding-top: 10%

  .game_on
    font-size: 30px
    color: #2CB459
    display: block
    text-transform :uppercase
    font-weight: bold
  .keep_selections
    color #1493ff
    font-weight normal
    font-size 16px
    font-weight 600

  .bet_placed
    h3
      font-weight: normal !important
      color: #06283b
      font-size: 16px
    .totals
      flex-direction: column
      border-top: 1px solid #CFD6DB
      margin: 50px -10px 0 -10px
      padding: 0 10px;
      @media tablet-and-below
        position: absolute
        margin: 0
        padding: 0
        bottom: 80px
        left: 15px
        right: 15px
        border-top: 0px
      div
        display: flex
        margin-top: 3px
        line-height: 25px
        label
          font-size: 14px
          color: #06283b
          text-transform: uppercase
          flex: 1 1 auto
          font-weight: normal
        .value
          margin-left: auto
          flex-direction: column
          color: #06283b
          font-size: 14px
          font-weight: bold
          @media tablet-and-below
            font-size: 16px

      .potential-return
        .value
          @media tablet-and-above
            color: #1493FF


  .action_buttons
    display: flex
    align-items: stretch

    .column-left,
    .column-right
      flex: 1

    .column-left
      flex-basis: 50%
      margin-right: 8px
    .column-right
      flex-basis: 50%
    .btn
      width: 100%
      border-radius: 2px
      font-size: 14px
      font-weight: bold
    .secondary
      background: #ffffff !important
      border: 1px solid #CFD6DB !important
      margin-left: -2px
      color: #1493FF
    .primary
      background: #1493FF !important
      border: 1px solid #1493FF !important
      color: #fff
      margin-left: 4px
      &:hover
        background-color: #0d7fe1

  .action-btns
    border-top: 1px solid #CFD6DB
    .betPlacement
      padding: 0
    .acceptChanges
      background-color: #2a77aa  !important
      font-size: 14px
      font-weight: bold
      &:hover
        background-color: #0d7fe1


  .not-geolocated .loader-container {
    .loader {
      border-width: 3px;
      border-top-width: 3px;
      border-top-color: #888888;
      width: 20px;
      height: 20px;
    }
  }

.SBbetSlip.InProgress .bets {
  background: #E5E5E5;
  opacity: 0.5
}

.SBbetSlip.InProgress .betPlacement {
  padding: 0px;
}

.add-bets-container
  background-color #4994D9
  border-radius 5px
  display flex
  align-items center
  justify-content center
  margin 10px
  .ab-sign
    background-color #fff
    display flex
    align-items center
    justify-content center
    text-align center
    width 43px
    height 43px
    margin 5px
    border-radius 5px

  .pd-icon
    padding 5px
    background-color #fff
    margin 5px
    border-radius 5px
    &:before
      color #4994d9
      font-size 40px
      font-weight bold
      display flex
      align-items center
      justify-content center
      @media mobile-big-and-below
        margin-top 1px
        margin-left -1px

  .ab-info-msg
    flex 1
    .ab-label
      color white
      text-transform uppercase
      display block
      text-align center
      font-size 17px
      &:first-child
        font-weight 500

</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/Betslip.vue